<!--
  商品详情
  lovi 2020-06-24
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('life.commodityDetails')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="content-wrapper" v-if="detail.product_id">
      <scroll>
        <van-swipe class="swipe-image" :autoplay="3000" indicator-color="white">
          <van-swipe-item>
            <div class="image"><img :src="httpUrl + detail.product_img" /></div>
          </van-swipe-item>
        </van-swipe>
        <div class="info">
          <h1>{{ detail.product_name }}</h1>
          <p class="">
            <span class="text-gray">
              {{ $t("life.monthSold") }}
              {{ detail.month_sales }}
            </span>
          </p>
          <div class="price-wrap">
            <div class="price">
              <span class="text-red">{{ detail.selling_price }}P</span>
              <span
                v-if="detail.original_price"
                class="original_price text-gray"
              >
                {{ detail.original_price }}P
              </span>
            </div>
            <van-stepper
              v-model="detail.count"
              :min="0"
              theme="round"
              button-size="22"
              :input-width="detail.count == 0 ? '0' : '28'"
              disable-input
              :show-minus="detail.count ? true : false"
              @change="stepperChange"
            />
          </div>
        </div>
        <div class="detail">
          <h3>{{ $t("life.commodityDetails") }}</h3>
          <pre v-html="detail.details"></pre>
        </div>
      </scroll>
    </div>
    <shop-cart v-if="detail.product_id" :activity="couponData.activity" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ShopCart from "@/components/life/shopCart";
export default {
  name: "commodity",
  meta: {
    service: false // 客服
  },
  components: {
    ShopCart
  },
  data() {
    return {
      shopId: "",
      proId: "",
      detail: {},
      couponData: {}
    };
  },
  created() {
    this.shopId = this.$route.query.shopId;
    this.proId = this.$route.query.proId;
    this.getStoreProductDetail();
    this.getDisccountStoreInfomation();
  },
  mounted() {},
  computed: {
    ...mapGetters(["shopCartData"])
  },
  methods: {
    stepperChange() {
      // 操作步进器
      let obj = this.detail;
      obj.shopId = this.shopId;
      this.$store.dispatch("SET_SHOPCART_DATA", obj);
    },
    initializeShopCart(arr) {
      // 初始化处理购物车数据
      let vm = this;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].product_id == vm.detail.product_id) {
          vm.$set(vm.detail, "count", arr[i].count);
        }
      }
    },
    getStoreProductDetail() {
      let vm = this;
      let params = {};
      params.shop_id = vm.shopId;
      params.product_id = vm.proId;
      vm.$post("/app/store/getStoreProductDetail", params, {
        loading: true
      }).then(res => {
        console.log("getStoreProductDetail", res);
        vm.detail = res.list;
        vm.initializeShopCart(vm.shopCartData);
      });
    },
    getDisccountStoreInfomation() {
      //店铺优惠信息
      let vm = this;
      let params = {};
      params.shop_id = vm.shopId;
      vm.$post("/app/store/getDisccountStoreInfomation", params, {
        loading: true
      }).then(res => {
        console.log("getDisccountStoreInfomation", res);
        vm.couponData = res.list;
      });
    }
  },
  watch: {
    shopCartData: {
      handler: function(arr) {
        console.log("commodity.shopCartData");
        this.initializeShopCart(arr);
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.swipe-image {
  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    width: 100%;
    height: 360px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  /deep/.van-swipe__indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
}
.info {
  flex: 1;
  padding: 10px;
  line-height: 1;
  font-size: 10px;
  background: #fff;
  h1 {
    font-size: 16px;
    font-weight: 400;
  }
  p {
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .price-wrap {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .price {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      span {
        &.text-red {
          font-size: 18px;
        }
        &.original_price {
          margin-left: 5px;
          text-decoration: line-through;
        }
      }
    }
    /deep/.van-stepper {
      .van-stepper__minus {
        color: #1a83ff;
        border-color: #1a83ff;
      }
      .van-stepper__plus {
        background: #1a83ff;
      }
    }
  }
}
.detail {
  border-top: 10px solid #f4f4f4;
  padding: 10px;
  background: #fff;
  h3 {
    font-size: 16px;
    font-weight: 400;
  }
  pre {
    font-size: 14px;
    line-height: 1.4;
  }
}
</style>
